import { z } from 'zod'

export const assignDeviceToClientSchema = z.object({
  id: z.number(),
  unpayCredit: z.boolean(),
  contractResponse: z
    .object({
      message: z.string(),
      data: z.object({
        pdfBase64: z.string(),
        fileName: z.string(),
        contentType: z.string(),
        verificationCode: z.string(),
        verificationUrl: z.string()
      }),
      status: z.number()
    })
    .nullable()
})
